<div class="flex justify-center gap-4">
  <ng-content />
</div>
